var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.loading,"z-index":"9999999"}},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require("@/assets/img/loading.gif"),"alt":""}}),_c('div',{staticClass:"fc9EB2B5 mt16 fs12"},[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }